import { FormInput } from "@/components";
// TODO delete models influencer
import { ValidationObserver } from "vee-validate";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { UploadFileStatus } from "@/enums";

@Component({
    components: {
        FormInput,
        ValidationObserver,
    },
})

// TODO clean useless
export default class InfluencersModal extends Vue {
    @Prop({ default: false, type: Boolean })
    public state?: boolean;

    @Prop()
    public initialFilename?: string;

    @Prop({ type: File })
    public currentFile: File;

    public files: File[] = [];

    public localState = false;

    public droppable = true;

    constructor() {
        super();

        if (this.currentFile) {
            this.files.push(this.currentFile);
        }
    }

    // TODO get influencer file at start?
    // TODO restrict the file type to xlsx, xls files.

    @Watch("state")
    setLocalState(): void {
        this.localState = this.state;
    }

    @Watch("localState")
    setCloseState(): void {
        if (!this.localState) {
            this.$emit("close");
        }
    }


    @Watch("initialBlob")
    initInfluencerFile(): void {
        // TODO remove the size of the file in display or get file size or return blob with filename
        this.files = this.initialBlob ? [new File([this.initialBlob], this.initialFilename)] : [];
    }

    get initialBlob(): Blob {
        return this.$store.getters["app/influencers"];
    }

    close(): void {
        this.$emit("close");
    }

    save(): void {
        let fileStatus = this.files.length > 0 ? UploadFileStatus.Updated : this.initialFilename !== "" ? UploadFileStatus.Deleted : UploadFileStatus.None;
        this.sendChanges(fileStatus);
    }

    async mounted(): Promise<void>{
        await this.$store.dispatch("app/loadInfluencerTemplate", true);
    }


    // TODO ne pas load automatiquement le template?
    get influencersTemplateLink(): string {
        const url = window.URL || window.webkitURL;
        const data = this.$store.getters["app/influencersTemplate"];
        return data? url.createObjectURL(data) : "";
    }


    // TODO refacto pour mise en commun avec media?
    // TODO Tester avec 1 ou plusieurs fichiers ou 0
    addDroppedFiles(event: DragEvent) {
        const droppedFiles = event.dataTransfer.files;
        if (droppedFiles.length == 1) {
            this.files = [droppedFiles[0]];
        }
    }

    // TODO refacto pour mise en commun avec media?
    addSelectedFile(selectedFile: File) {
        if (selectedFile) {
            this.files = [selectedFile];
        }
    }

    // TODO refacto pour mise en commun avec media?
    removeFile(index) {
        this.files = [
            ...this.files.slice(0, index),
            ...this.files.slice(index + 1),
        ];
    }


    sendChanges(fileStatus: UploadFileStatus): void {
        this.$emit("changeInfluencerFile", this.files, fileStatus);
    }

    async dragEnterEventHandler(event: DragEvent) {
        event.stopPropagation();
        const draggedFiles = event.dataTransfer.items;
        this.droppable = draggedFiles.length === 1;
        if(!this.droppable){
            await this.timeoutAsync(4000);
            this.droppable = true;
        }
    }


    dragEndEventHandler(event: DragEvent){
        this.droppable = true;
    }

    private timeoutAsync(delay: number): Promise<void>{
        return new Promise(resolve => setTimeout( _ => {
            resolve();
        }
        , delay));
    }
}
